import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getMembership, loadProfile } from '@techstyle/react-accounts';

import {
  isClearanceItem,
  isPreorderable,
  isProductCustomizable,
  getAdditionalSaleDiscount,
  getProductPromos,
  getShouldShowPromoPrice,
  getIsVipCart,
} from '../../utils/selectors';

import ProductDetailHeader from './ProductDetailHeader';

export function mapStateToProps(state, ownProps) {
  return {
    additionalDiscounts: getAdditionalSaleDiscount(state),
    isBorderfreeCustomer: state.borderfree.isBorderfreeCustomer,
    isInfluencer: !!state.customer.isInfluencer,
    isLead: getMembership(state).isLead,
    isPaygo: getMembership(state).isPaygo,
    isPreorderable: isPreorderable(state, ownProps),
    isProductCustomizable: isProductCustomizable(state, ownProps),
    isVip: getMembership(state).isVip,
    isClearanceItem: isClearanceItem(state, ownProps),
    promos: getProductPromos(state, ownProps),
    shouldShowPromoPrice: getShouldShowPromoPrice(state, ownProps),
    isVipCart: getIsVipCart(state),
    shouldDisplayNewProductPricing: ownProps?.shouldDisplayNewProductPricing,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadProfile }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetailHeader);
